import { inject, Injectable } from '@angular/core';
import { StorageService } from '@core/storage/services/storage.service';
import { NavigationStorageData } from '@core/navigation/models/navigation-storage-data.interface';

@Injectable({
  providedIn: 'root',
})
export class NavigationStorageFacade {
  private readonly storageService = inject(StorageService);

  isNavigationItemCollapsed(navigationId: string): boolean {
    const navigationData = this.navigationData;

    if (!navigationData || !navigationData[navigationId]) {
      return true;
    }

    return navigationData[navigationId].isCollapsed;
  }

  setNavigationItemCollapsedState(navigationId: string, isCollapsed: boolean): void {
    const navigationData = this.navigationData ?? {};

    this.storageService.setNavigationData({ ...navigationData, [navigationId]: { isCollapsed } });
  }

  private get navigationData(): NavigationStorageData | undefined {
    return this.storageService.getNavigationData();
  }
}
